import { render } from "./ReportDataTableYear.vue?vue&type=template&id=fdd81b68&scoped=true"
import script from "./ReportDataTableYear.vue?vue&type=script&lang=js"
export * from "./ReportDataTableYear.vue?vue&type=script&lang=js"

import "./ReportDataTableYear.vue?vue&type=style&index=0&id=fdd81b68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd81b68"]])

export default __exports__